import { Flex, Heading } from "@chakra-ui/react";
import { StrategyTab, NextPageButton } from "../components";

const LearnStrategy = () => {
  return (
    <Flex flex="1" direction="column" p={"10px 35px 35px 35px"}>
      {" "}
      <Heading fontSize="lg" align="center" m="30px">
        “Anyone can learn the basics of a card game, but can they go the crucial
        step further and adapt to a winning strategy?”
      </Heading>
      <StrategyTab />
      <NextPageButton to="/practice" label="Practice" />
    </Flex>
  );
};
export default LearnStrategy;
